export function withLiveMap(map, fn, options = {}) {
  if (!map) return false;
  try {
    const container = map.getContainer?.();
    if (!container?.parentNode || !map._mapPane) return false;
    if (options.stop !== false && typeof map.stop === 'function') map.stop();
    fn(map);
    return true;
  } catch (e) {
    console.warn('[Map] Skipped map operation:', e?.message || e);
    return false;
  }
}

export function isLiveMap(map) {
  try {
    return !!(map && map.getContainer?.()?.parentNode && map._mapPane);
  } catch {
    return false;
  }
}
